import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { PostHogProvider } from "posthog-js/react";
import { LicenseInfo } from '@mui/x-license';

// Set MUI X Pro license key
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

// Reload once when a deploy invalidates old hashed chunks (stale index.html).
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "chunk-reload-at";
  const last = Number(sessionStorage.getItem(KEY) ?? 0);
  if (Date.now() - last > 60_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    event.preventDefault(); // don't surface the error; we're recovering
    window.location.reload();
  }
});

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-11-30",
  // Expose the instance like the script snippet would — console debugging
  // (e.g. posthog.getActiveMatchingSurveys) is impossible without it.
  loaded: (ph: unknown) => {
    (window as unknown as { posthog: unknown }).posthog = ph;
  },
} as const;

createRoot(document.getElementById("root")!).render(
  <PostHogProvider
    apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
    options={options}
  >
    <App />
  </PostHogProvider>
);
